import * as React from 'react'
import { Box, Modal, TextField, Typography } from '@mui/material'
import useStylesRouteModal from './useStylesRouteModal'
import CloseIcon from '@mui/icons-material/Close'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  height: 200,
  bgcolor: 'white',
  p: 4,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export default function RouteModal ({
  openModal,
  setOpenModal,
  handleGetFilterRecycle
}) {
  const [path, setPath] = React.useState('')
  const handleClose = () => {
    setOpenModal(false)
  }

  const classes = useStylesRouteModal()

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: 'medium',
              ml: 70,
              color: '#263057',
              cursor: 'pointer'
            }}
            onClick={handleClose}
          />
          <Typography
            sx={{
              fontFamily: 'Raleway',
              color: '#263057',

              ml: '5%'
            }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Buscar documento por ruta
          </Typography>
          <Typography
            id="modal-modal-description"
            className={classes.typography}
          >
            Ingrese la ruta exacta de ubicación del documento
          </Typography>
          <TextField
            className={classes.textFieldStyle}
            sx={{ width: '90%' }}
            autoFocus
            margin="dense"
            id="name"
            type="text"
            placeholder="Ej: /ERREPAR SERVICIOS CONTABLES/FIRM-USERS-ROOT/Facundo Vignoles/opcion1.jpg"
            variant="standard"
            value={path}
            onChange={(event) => setPath(event.target.value)}
          />

          <Box className={classes.buttons}>
            <ButtonConfirm
              handleGetFilterRecycle={handleGetFilterRecycle}
              path={path}
              handleClose={handleClose}
            />
            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
function ButtonConfirm ({ handleGetFilterRecycle, path, handleClose }) {
  const classes = useStylesRouteModal()
  return (
    <Box
      className={classes.confirmButton}
      sx={{
        '&:hover': {
          bgcolor: '#1BF57F'
        }
      }}
      // onClick={handleAddExtend}
    >
      <Typography
        onClick={async () => {
          await handleGetFilterRecycle('search_route', path)
          handleClose()
        }}
        className={classes.confirmButtonTypography}
      >
        Buscar
      </Typography>
    </Box>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStylesRouteModal()
  return (
    <Box className={classes.closeButton}>
      <Typography
        onClick={() => {
          handleClose()
        }}
        className={classes.closeButtonColor}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
